<template>
  <div class="page" v-wechat-title="$route.meta.title='评价'">
    <div class="select-more-comment border-box">
      <div class="clearfix" style="height: .6rem;line-height:.60rem;">
        <span class="fl">全部评论{{total}}条</span>
        <p class="star-box-new clearfix">
          <img :src="(score>=2)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
          <img :src="(score>=4)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
          <img :src="(score>=6)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
          <img :src="(score>=8)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
          <img :src="(score>=10)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
          <span>{{score}}分</span>
        </p>
      </div>

      <div class="tag-list">
        <span :class="state==''?'curr':''"  @click="changeCom('')">全部</span>
        <span :class="state==1?'curr':''"  @click="changeCom(1)">今日</span>
        <span :class="state==2?'curr':''"  @click="changeCom(2)">好评</span>
        <span :class="state==3?'curr':''"  @click="changeCom(3)">差评</span>
        <span :class="state==4?'curr':''"  @click="changeCom(4)">有图</span>
      </div>


    </div>


    <div class="container border-box">

      <!--新增底部评论详情列表-->
      <div class="comments-list border-box account-list-sr">
        <div v-for="(item,index) in root" :key="index" class="comments-list-data box border-box">
          <p class="block head-img-box">
            <img class="img" v-lazy="item.rzimg?item.rzimg:item.headimg"  :key="index"/>
          </p>

          <div class="flex comments-list-info  border-box">
            <div class="comments-person-box box ">
              <div class="block comments-person">
                <p class="comments-person-name hide">{{item.name}}</p>
                <p class="star-level">
                  <template v-for="(star,index) in [2,4,6,8,10]">
                    <img v-if="item.score>=star" src="../../assets/icon_com.png"/>
                    <img v-else  src="../../assets/start_nor.png" />
                  </template>
                </p>
              </div>
            </div>

            <div class="comments-detail border-box">
              <p class="comments-detail-top">{{item.content}}</p>
            </div>

            <div v-if="item.allimg" class="comments-img box border-box">
              <img v-for="(ite,index) in item.allimg"  @click="seeImg(index,item.allimg)" v-lazy="ite"  :key="index"/>
            </div>

            <div class="block comments-person-time">
              {{item.addtime}}
            </div>
          </div>
        </div>

        <p class="load-tip" ref="loadtip">{{loadText}}</p>
      </div>
    </div>

    <div class="comment-btn-box">
      <p @click="commentShow=1" class="comment-btn">我要评论</p>
    </div>

    <!--新版本评论弹窗8-21-->
    <AlertComment :page="'maptour'" :shopid="shopid" :class="{'curr':commentShow==1,'none':commentShow!=1}"  @child-Comment="closeComment"></AlertComment>

  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import AlertComment from '../../components/AlertComment'
  import {mapViewComment} from "@/service/getData";
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import {wxImgPreview,wxShareme} from '@/utils/wechat'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        shopid: this.$route.query.shopid, //景区id
        userInfo: {}, //用户信息
        page: 1,
        rows: 20,
        loadText: "数据加载中",
        state: '', //筛选条件

        root:'',//评论列表
        total:'',//评论总条数

        commentShow:0,//评论弹窗
        score: 10, //评分

      }
    },
    computed: {

    },
    created(){

      this.$loading.show('数据加载中');

      this.id = this.$route.query.id;
      this.userInfo = getStore("userInfo");

      this.initData(this.page);

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {
      //评论
      async initData(page){
        let res = await mapViewComment({
          page: page,
          rows: this.rows,
          shopid: this.shopid,
          state: this.state
        });
        console.log(res.data);

        if (res.errcode === "00000"){
          this.$loading.hide();

          console.log(res)

          this.total = res.data.total
          let root = res.data.root
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          if(res.data.score>0){
            this.score = res.data.score
          }
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      //评论弹窗隐藏
      closeComment :function(msg){
        this.commentShow = msg.commentShow;
        if(msg.success){
          this.page = 1;
          this.root = [];
          this.initData(this.page);
        }
      },

      //筛选评价
      changeCom: function (val){
        console.log(val)
        this.state = val;
        this.page = 1;
        this.root = [];
        this.initData(this.page);
      },

      //图片预览
      seeImg(ind,imgs){
        wxImgPreview(imgs[ind],imgs);
      }

    },
    components: {
      AlertComment
    },

  }

</script>

<style scoped>
  .container{background:#fff;padding-top: 1.28rem;}
  .select-more-comment{position: fixed;left:0; width:100%;height:1.28rem;padding:0 .24rem;font-size:.28rem;color:#333;background:#f6f6f6; z-index: 2;}
  .comment-btn-box{position:fixed;left:0;bottom:0;z-index:2;height:1.4rem;width:100%;background:#fff;}
  .comment-btn{position:absolute;left:.24rem;right:.24rem;top:50%;height:.70rem;line-height:.70rem;margin-top:-.35rem;color:#fff;background:#faaf39;border-radius:.30rem;text-align:center;letter-spacing:.05rem;font-size:.32rem;}

  .tag-list{position: relative; margin-top: .05rem; height: .46rem; }
  .tag-list span{ display: inline-block; margin-right: .25rem; width: .9rem; height: .46rem;line-height: .46rem; font-size: .26rem; color: #333; text-align: center; background-color: rgba(250,175,57,.2); border-radius: .04rem; cursor: pointer; }
  .tag-list span.curr{ background-color: #faaf39; color: #fff;  }

  .star-box-new{ display: inline-block; height:.42rem;margin-top: .1rem;margin-left: .12rem;}
  .star-box-new img{float:left;width: auto;height: .25rem;margin-right: .09rem;margin-top: .085rem;}
  .star-box-new span{float: left;margin-left:.13rem;font: .24rem/.44rem "Microsoft YaHei";color: #c6c6c6;}
</style>



// WEBPACK FOOTER //
// src/page/map/map-comment.vue